import { withTranslation } from "next-i18next";
import { useEffect, useRef } from "react";
import classNames from "classnames";
import {
  useIsAddedToUserListToastOpen,
  useCloseAddedToUserListToast,
  useUserListsManager,
} from "@hooks/use-userlists";
import { useButtonEventTracking } from "@hooks/use-button-event-tracking";
import Link from "@components/core/Link";
import ProductImagesTrio from "@components/core/ProductImagesTrio";

function AddedToUserListToast({ t }) {
  const trackEvent = useButtonEventTracking();
  const { userList } = useUserListsManager();
  const isAddedToUserListToastOpen = useIsAddedToUserListToastOpen();
  const closeAddedToUserListToast = useCloseAddedToUserListToast();

  const closeTimeout = useRef(null);

  function handleClick() {
    trackEvent("ViewListFromToast");
  }

  useEffect(() => {
    if (isAddedToUserListToastOpen) {
      closeTimeout.current = setTimeout(() => {
        closeAddedToUserListToast();
      }, 5000);
    }

    return () => {
      if (closeTimeout.current) clearTimeout(closeTimeout.current);
    };
  }, [isAddedToUserListToastOpen, closeAddedToUserListToast]);

  return (
    <div className="userlist-toast">
      <div className="userlist-toast-container">
        <Link
          href={`/userlist/${userList.uuid}`}
          className="w-100"
          onClick={handleClick}
        >
          <div
            className={classNames("userlist-toast-content", isAddedToUserListToastOpen && "open")}
          >
            <div className="d-flex align-items-center pe-3">
              <ProductImagesTrio
                images={userList.first_products_pictures}
                className="userlist-toast-trio-images-container"
              />

              <p className="mb-0 text-white text-2-lines">
                {t("common:userlist.added_to_userlist", { userListName: userList.name })}
              </p>
            </div>

            <div>
              <p className="text-white mb-0 userlist-toast-action text-1-line">
                {t("common:userlist.see_userlist")}
              </p>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default withTranslation("common")(AddedToUserListToast);
